export default __webpack_public_path__ + "740c8034ea0705abe64c9a968e6eefbe.png";